import {ValueAndLabelModel} from '../../../../model/valueAndLabel.model';

export class CountryModel extends ValueAndLabelModel {
    dialingCode: string;
}

export enum Countries {
    FRANCE = 'FR',
    BELGIUM = 'BE',
}
